import { useMutation, UseMutationOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

type ToggleStatusProps = {
  sessionId: string;
  documentId: string;
  status: boolean;
};

async function toggleFinishedStatus({
  sessionId,
  documentId,
  status
}: ToggleStatusProps): Promise<ToggleStatusProps> {
  const statusString = status ? 'true' : 'false';
  const url = `${POST_URL(sessionId, documentId, statusString).finalize}`;

  const { data } = await Axios.put(url);
  return data;
}

export function useToggleFinishedStatus(
  options?: UseMutationOptions<
    ToggleStatusProps,
    AxiosError<BaseError>,
    ToggleStatusProps
  >
) {
  return useMutation<
    ToggleStatusProps,
    AxiosError<BaseError>,
    ToggleStatusProps
  >((props: ToggleStatusProps) => toggleFinishedStatus(props), {
    ...(options ?? {})
  });
}
